import React from 'react';
import './index.css';
import App from './App';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';


const rootElement = document.getElementById('root');
ReactDOM.hydrateRoot(rootElement,
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

/* const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); */